import {
    GET_QUERYBUILDER_PROFILEGROUPS,
    GET_QUERYBUILDER_PROFILEGROUPS_SUCCESS,
    GET_QUERYBUILDER_PROFILES,
    GET_QUERYBUILDER_PROFILES_SUCCESS,
    GET_QUERYBUILDER_PROFILEFILTERS,
    GET_QUERYBUILDER_PROFILEFILTERS_SUCCESS,
    QUERYBUILDER_API_ERROR
  } from "./actionTypes"
  
  
  export const getQueryBuilderProfileGroupListAction = () => ({
    type: GET_QUERYBUILDER_PROFILEGROUPS,
  })
  
  export const getQueryBuilderProfileGroupListSuccessAction = record => ({
    type: GET_QUERYBUILDER_PROFILEGROUPS_SUCCESS,
    payload: record,
  })

  export const getQueryBuilderProfileListAction = guid => ({
    type: GET_QUERYBUILDER_PROFILES,
    payload: guid,
  })
  
  export const getQueryBuilderProfileListSuccessAction = record => ({
    type: GET_QUERYBUILDER_PROFILES_SUCCESS,
    payload: record,
  })

  export const getQueryBuilderProfileFilterListAction = guid => ({
    type: GET_QUERYBUILDER_PROFILEFILTERS,
    payload: guid,
  })
  
  export const getQueryBuilderProfileFilterListSuccessAction = record => ({
    type: GET_QUERYBUILDER_PROFILEFILTERS_SUCCESS,
    payload: record,
  })
  
  export const apiQueryBuilderApiErrorAction = error => {
    return {
      type: QUERYBUILDER_API_ERROR,
      payload: error,
    }
  }
  
  